<template>
  <setting-section
    class="manager-settings"
    title="Manager Settings"
    :help="$t('configHelp.administrator')"
  >
    <el-row :gutter="20">
      <el-col :span="6">
        <el-form-item label="Manager Function (on-device admin menu lock)" prop="isOpen">
          <!-- 仅切换设备自身管理菜单的锁定状态，与门户账号权限无关；
               密码字段与此开关的开合状态无关，始终展示（见下方 defaultPasswordWarn 相关修复）。 -->
          <setting-switch v-model="config.isOpen"></setting-switch>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item label="Password" prop="passWord">
          <el-input
            v-model="config.passWord"
            placeholder="Enter password"
            autocomplete="off"
            :class="{ 'cfg-input--warn': passWordIsDefault }"
          />
          <!-- 出厂默认密码提醒：仅在该字段处提示 -->
          <div v-if="passWordIsDefault" class="cfg-field-warn">
            <i class="el-icon-warning-outline"></i> {{ $t('machineConfig.defaultPasswordWarn') }}
          </div>
        </el-form-item>
      </el-col>
    </el-row>
  </setting-section>
</template>

<script>
import { isDefaultAdminPassword } from '@/utils/machineDefaults';
import SettingSection from '../SettingSection.vue';
import SettingSwitch from '../SettingSwitch.vue';

export default {
  name: 'ManagerSettings',
  components: { SettingSection, SettingSwitch },
  props: {
    config: { type: Object, default: () => ({}) },
    yesNo: { type: Array, default: () => [] }
  },
  computed: {
    // 设备管理密码仍为出厂默认 → 字段级提醒
    passWordIsDefault() {
      return isDefaultAdminPassword(this.config && this.config.passWord);
    }
  }
};
</script>

<style lang="scss" scoped>
.manager-settings {
  /* 出厂默认密码：字段级提醒 */
  .cfg-input--warn ::v-deep .el-input__inner {
    border-color: var(--vtm-warn);
    background: var(--vtm-warn-soft);
  }
  .cfg-field-warn {
    margin-top: 2px;
    font-size: 12px;
    line-height: 1.45;
    color: var(--vtm-warn);

    i {
      margin-right: 3px;
    }
  }
}
</style>
